import { render, staticRenderFns } from "./ReceiptsList.vue?vue&type=template&id=25e906c9"
import script from "./ReceiptsList.vue?vue&type=script&lang=js"
export * from "./ReceiptsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports